/* eslint-disable react/prop-types */
import React from 'react';
import cx from 'classnames';
import { ApplicationStatus } from "../../../Applications/ApplicationStatus";
import Checkbox from "../../../core/input/Checkbox";
var ApplicationDetail = function ApplicationDetail(_ref) {
  var application = _ref.application,
    applicationId = _ref.application_id,
    schoolName = _ref.schoolName,
    studentName = _ref.studentName,
    programName = _ref.programName,
    mostRecentNoteAuthorType = _ref.mostRecentNoteAuthorType,
    sendNoteToApplication = _ref.sendNoteToApplication,
    onToggleSendNoteToApplication = _ref.onToggleSendNoteToApplication;
  return /*#__PURE__*/React.createElement("tr", {
    className: cx({
      error: !application,
      selected: application && sendNoteToApplication
    })
  }, /*#__PURE__*/React.createElement("td", null, applicationId), /*#__PURE__*/React.createElement("td", null, studentName), /*#__PURE__*/React.createElement("td", null, schoolName), /*#__PURE__*/React.createElement("td", null, programName), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ApplicationStatus, {
    application: application
  })), /*#__PURE__*/React.createElement("td", null, mostRecentNoteAuthorType), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Checkbox, {
    inputValue: sendNoteToApplication,
    onChange: onToggleSendNoteToApplication,
    name: applicationId,
    label: "Include application ".concat(applicationId)
  })));
};
export default ApplicationDetail;